import { ActionReducerMap } from "@ngrx/store";
import { routerReducer } from "@ngrx/router-store";

import { RouterState } from "../router.state";

export const reducer: ActionReducerMap<RouterState> = {
  router: routerReducer
};
